if (!customElements.get('lq-countdown')) {
  customElements.define(
    'lq-countdown',
    class LQCountdown extends HTMLElement {
      constructor() {
        super();

        this.arrival_date = this.dataset.endDate;
        // parse as UTC then adjust for BST if needed
        let utcTime = new Date(`${this.arrival_date} UTC`).getTime();
        if (this.isBritishSummerTime()) {
          utcTime -= 60 * 60 * 1000; // reduce 1 hour for BST
        }
        this.countDownDate = utcTime;

        this.days = this.querySelector('.count_down_days');
        this.hours = this.querySelector('.count_down_hours');
        this.minutes = this.querySelector('.count_down_minutes');
        this.seconds = this.querySelector('.count_down_seconds');
      }

      // detects DST by comparing Jan/Jul offsets (works for Europe/London)
      isBritishSummerTime(date = new Date()) {
        const year = date.getFullYear();
        const janOffset = new Date(year, 0, 1).getTimezoneOffset();
        const julOffset = new Date(year, 6, 1).getTimezoneOffset();
        const stdOffset = Math.max(janOffset, julOffset);
        return date.getTimezoneOffset() < stdOffset;
      }

      connectedCallback() {
        this.timerID = setInterval(() => {
          this.countDownInterval();
        }, 1000);

        setTimeout(() => {
          this.classList.remove("hidden");
        }, 1000);
      }

      countDownInterval() {
        let now = new Date().getTime();
        let distance = this.countDownDate - now;

        if (distance >= 0) {
          let days = Math.floor(distance / (1000 * 60 * 60 * 24));
          let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          let seconds = Math.floor((distance % (1000 * 60)) / 1000);

          this.setInnerText(this.days, days);
          this.setInnerText(this.hours, hours);
          this.setInnerText(this.minutes, minutes);
          this.setInnerText(this.seconds, seconds);

        } else if (distance >= -1000) {
          location.reload();
        } else {
          clearInterval(this.timerID);
          if (this.querySelector('.countdown_end_message')) {
            this.querySelector('.countdown_end_message').classList.remove("hidden");
          }
        }
      }

      setInnerText = (element, value) => {
        if (value < 10) {
          value = "0" + value;
        }
        element.innerText = value;
      }
    }
  );
}